import { createDraftSafeSelector, createSlice } from '@reduxjs/toolkit'

import { getOSTheme } from 'src/Utils/getOSTheme'

import { NameSpace } from '../types'
import { RootState } from '..'

export type ThemeMode = 'light' | 'dark' | 'auto'

export interface ThemeState {
  mode: ThemeMode
  osTheme: 'light' | 'dark'
}

const initialState: ThemeState = {
  mode: 'auto',
  osTheme: getOSTheme(),
}

export const themeProcess = createSlice({
  initialState,
  name: NameSpace.Theme,
  reducers: {
    setTheme(state, action: { payload: ThemeMode }) {
      state.mode = action.payload
    },
    setOsTheme(state, action: { payload: 'light' | 'dark' }) {
      state.osTheme = action.payload
    },
  },
})

export const { setTheme, setOsTheme } = themeProcess.actions

const getState = (state: RootState): ThemeState => state.theme

export const getThemeMode = createDraftSafeSelector(
  getState,
  ({ mode }) => mode,
)

export const getResolvedTheme = createDraftSafeSelector(
  getState,
  ({ mode, osTheme }): 'light' | 'dark' =>
    mode === 'auto' ? (osTheme ?? getOSTheme()) : mode,
)
